import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Button, Modal } from 'react-bootstrap';
import CustomerSearch from 'components/site/customer-search';
import { titleize } from 'underscore.string';
import { isIntermodalShipmentType } from 'helpers/shipment-types';
import { withTranslation } from 'react-i18next';
import { sluggify } from 'utils/localization/utils';
import CustomerSearchWithPreferences from 'components/site/customer-search-with-preferences';
import { areShipmentsHaveSameShipper } from 'components/modules/shipments/utils';
import { getShipmentPreferenceType } from 'helpers/shipments';
import { getCarrierPreferencesByType } from 'utils/CarrierPreferencesUtils';
import Alert from 'components/ui/Alert';
import DriverSuggestions from './DriverSuggestions';

class AssignDriverModal extends Component {
  constructor(props) {
    super(props);
    this.state = this.getInitialState();
  }

  async componentDidUpdate(prevProps) {
    const shipments = this.props.shipments || [];
    if (
      areShipmentsHaveSameShipper(shipments) &&
      this.props.show &&
      prevProps.show !== this.props.show
    ) {
      const shipment = this.props.shipments.length
        ? this.props.shipments[0]
        : this.props.shipment;

      if (!shipment) {
        return;
      }
      const { shipment_type: shipmentType } = shipment;
      const preferenceType = getShipmentPreferenceType(shipmentType);
      if (!preferenceType) {
        return;
      }

      const carrierPreferences = await getCarrierPreferencesByType(
        shipment.shipper.id || shipment.shipper._id,
        preferenceType,
      );
      this.setState({ carrierPreferences });
    }
  }

  getInitialState() {
    return {
      error: null,
      selectedDriver: null,
      isCarrierTrained: true,
      carrierPreferences: null,
    };
  }

  assignDriver() {
    if (this.state.selectedDriver)
      this.onAssignDriver(this.state.selectedDriver);
  }

  onAssignDriver(driver) {
    if (!driver) {
      return;
    }

    // Handle data format for driver and carrier
    driver = {
      ...driver,
      is_broker: driver.is_broker || driver?.carrierData?.is_broker,
    };

    let shipmentPayload = this.props.shipments?.length
      ? this.props.shipments
      : this.props.shipment;

    if (driver.is_broker && this.props.onAssignBrokerCarrier) {
      this.props.onAssignBrokerCarrier(shipmentPayload, driver);
    } else {
      this.props.onAssignDriver(shipmentPayload, driver);
    }

    this.setState(this.getInitialState());
    this.handleClose();
  }

  handleClose() {
    this.props.onHide();
  }

  onSelectDropDown(item, value) {
    const isCarrierTrained =
      (value._type === 'Driver' &&
        value.carrierData &&
        value.carrierData.status &&
        value.carrierData.status === 'Trained') ||
      (value._type === 'Carrier' && value.status === 'Trained');
    if (value) {
      this.setState({ selectedDriver: value, isCarrierTrained });
    }
  }

  canNotProcessShipmentInPortPro(shipment) {
    const { stops } = shipment;

    if (shipment.shipment_type === 'drayage') {
      const order_type = shipment?.order?.order_type || '';

      const { selectedDriver } = this.state;

      return (
        selectedDriver?.portpro?.enabled &&
        (stops.length > 3 ||
          order_type === 'domestic' ||
          order_type === 'reload' ||
          (stops.length > 2 && order_type === 'reposition'))
      );
    }

    return false;
  }

  render() {
    const {
      shipment,
      showDrayageSelectionForShorthaul,
      hideDriverSuggestions,
    } = this.props;
    const isIntermodalShipment = isIntermodalShipmentType(shipment);
    const { carrierPreferences, isCarrierTrained } = this.state;
    const { assignCarrier, t, shipments } = this.props;
    const shipment_ids =
      this.props.shipments.length > 0
        ? this.props.shipments.map((shipment) => {
            return shipment.shipment_id;
          })
        : null;

    if (!shipment && !shipment_ids) {
      return null;
    }
    const display =
      shipment_ids && shipment_ids.length > 0
        ? shipment_ids.join(', ')
        : shipment.shipment_id;
    const count =
      shipment_ids && shipment_ids.length > 0 ? shipment_ids.length : 1;
    shipment.type = 'drayage';
    let customerType =
      isIntermodalShipment || showDrayageSelectionForShorthaul
        ? 'carriers'
        : 'drivers';
    customerType = assignCarrier ? 'carriers' : customerType;

    const type = customerType === 'carriers' ? 'carrier' : 'driver';
    const showSearchWithPreferences =
      areShipmentsHaveSameShipper(shipments) &&
      (shipment.shipment_type === 'drayage' ||
        shipment.shipment_type === 'rail' ||
        shipment.shipment_type === 'longhaul' ||
        shipment.shipment_type === 'dayrate' ||
        shipment.shipment_type === 'shorthaul');
    const canNotProcessShipmentInPortPro =
      this.canNotProcessShipmentInPortPro(shipment);

    return (
      <Modal
        bsSize="large"
        show={this.props.show}
        onHide={() => this.handleClose()}
        enforceFocus={false}
      >
        <Modal.Header data-testid="undefined-f11159de" closeButton>
          <strong data-testid="strong-ea593b98">
            {t('ASSIGN_TYPE_OF_SHIPMENTS', {
              type: t(sluggify(type), { count: 1 }),
              count,
              display,
            })}
          </strong>
          {!isCarrierTrained && (
            <Alert
              dataTestId="Alert-ca6fc200"
              className="mt-2"
              type="error"
              title={t('CARRIER_IS_NOT_TRAINED')}
            />
          )}
          {canNotProcessShipmentInPortPro && (
            <Alert
              dataTestId="Alert-06a54eee"
              className="mt-2"
              type="warning"
              title={t('ASSIGN_CARRIER_PORTPRO_WARNING')}
            />
          )}
        </Modal.Header>
        <Modal.Body data-testid="undefined-847ab11b">
          <h4 data-testid="h4-68ce41dd">
            {titleize(t('TYPE_SEARCH', { type: t(sluggify(type)) }))}
          </h4>
          <div className="relative">
            {showSearchWithPreferences ? (
              <CustomerSearchWithPreferences
                id="customer-search-input"
                clearOnSelect={false}
                type={customerType}
                assignField
                onSelect={(item, value) => this.onSelectDropDown(item, value)}
                placeholder={t('SEARCH_FOR_TYPE', {
                  type: t(sluggify(type), { count: 1 }),
                })}
                carrierPreferences={carrierPreferences}
                isDriver={type === 'driver'}
                dropdownStyle={{ maxHeight: '160px', overflow: 'auto' }}
                menuStyle={{
                  position: 'absolute',
                  top: 40,
                  left: 0,
                }}
              />
            ) : (
              <CustomerSearch
                id="customer-search-input"
                clearOnSelect={false}
                type={customerType}
                assignField
                dropdownStyle={{ maxHeight: '160px', overflow: 'auto' }}
                menuStyle={{
                  position: 'absolute',
                  top: 40,
                  left: 0,
                }}
                onSelect={(item, value) => this.onSelectDropDown(item, value)}
                placeholder={t('SEARCH_FOR_TYPE', {
                  type: t(sluggify(type), { count: 1 }),
                })}
              />
            )}
          </div>
          {!isIntermodalShipment && !showDrayageSelectionForShorthaul && (
            <div
              data-testid="div-cddbfdb7"
              className="flex justify-end py-4 space-x-2 border-b border-solid border-gray"
            >
              <Button onClick={() => this.handleClose()}>
                {titleize(t('CLOSE'))}
              </Button>
              <Button
                id="assign-button"
                className="shipment-assignDriverModal-assignDriver"
                bsStyle="primary"
                onClick={() => this.assignDriver()}
                disabled={!isCarrierTrained}
              >
                {t('ASSIGN')}
              </Button>
            </div>
          )}
          {type === 'driver' && !hideDriverSuggestions && (
            <div data-testid="div-b3d48cca">
              <DriverSuggestions
                carrierPreferences={carrierPreferences}
                shipment={shipment}
                shipments={this.props.shipments}
                onAssignDriver={this.onAssignDriver.bind(this)}
              />
              <hr data-testid="hr-dfe74289" />
            </div>
          )}
          {(isIntermodalShipment ||
            this.props.assignCarrier ||
            showDrayageSelectionForShorthaul) && (
            <div data-testid="div-2fca0440">
              <h4 data-testid="h4-941620e2">{titleize(t('DRIVER_SEARCH'))}</h4>
              {showSearchWithPreferences ? (
                <CustomerSearchWithPreferences
                  id="driver-search-input"
                  clearOnSelect={false}
                  type="drivers"
                  assignField
                  onSelect={(item, value) => this.onSelectDropDown(item, value)}
                  placeholder={t('SEARCH_FOR_DRIVER')}
                  carrierPreferences={carrierPreferences}
                  isDriver
                  dropdownStyle={{ maxHeight: '160px', overflow: 'auto' }}
                  menuStyle={{
                    position: 'absolute',
                    top: 40,
                    left: 0,
                  }}
                />
              ) : (
                <CustomerSearch
                  id="customer-search-input"
                  clearOnSelect={false}
                  type="drivers"
                  assignField
                  onSelect={(item, value) => this.onSelectDropDown(item, value)}
                  placeholder={t('SEARCH_FOR_TYPE', {
                    type: t(sluggify('driver'), { count: 1 }),
                  })}
                  dropdownStyle={{ maxHeight: '160px', overflow: 'auto' }}
                  menuStyle={{
                    position: 'absolute',
                    top: 40,
                    left: 0,
                  }}
                />
              )}
            </div>
          )}
        </Modal.Body>
        {(isIntermodalShipment || showDrayageSelectionForShorthaul) && (
          <Modal.Footer data-testid="undefined-afcd06d1">
            <Button onClick={() => this.handleClose()}>
              {titleize(t('CLOSE'))}
            </Button>
            <Button
              id="assign-button"
              className="shipment-assignDriverModal-assignDriver"
              bsStyle="primary"
              onClick={() => this.assignDriver()}
              disabled={!isCarrierTrained}
            >
              {t('ASSIGN')}
            </Button>
          </Modal.Footer>
        )}
      </Modal>
    );
  }
}

AssignDriverModal.propTypes = {
  shipment: PropTypes.object,
  onAssignDriver: PropTypes.func.isRequired,
};

export default withTranslation()(AssignDriverModal);
